import * as types from '../../lib/actionTypes.es6';
import { take, call, put } from 'redux-saga/effects';
import { getTaxConfigs, getTaxConfigRaw, publishTaxConfig, createTaxConfig } from '../../lib/requests.es6';
import * as actions from './actions.es6';
import { unAuthorizedNotification } from '../../lib/access.es6';
import { GAloggerException } from '../../lib/monitoring.es6';

export function* getTaxConfigsWatcher() {
  while (true) {
    const { payload: partner } = yield take(types.GET_TAX_CONFIGS_REQUEST);
    try {
      const response = yield call(getTaxConfigs, partner);
      yield put(actions.getTaxConfigsSuccess(response.data));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.getTaxConfigsFail(e.response ? e.response.data : {}));
    }
  }
}

export function* getTaxConfigRawWatcher() {
  while (true) {
    const { payload: { partner, type } } = yield take(types.GET_TAX_CONFIG_RAW_REQUEST);
    try {
      const response = yield call(getTaxConfigRaw, partner, type);
      yield put(actions.getTaxConfigRawSuccess(response.data.yaml));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.getTaxConfigRawFail(e.response ? e.response.data : {}));
    }
  }
}

export function* publishTaxConfigWatcher() {
  while (true) {
    const { payload: { partner, type, rawYaml } } = yield take(types.PUBLISH_TAX_CONFIG_REQUEST);
    try {
      const response = yield call(publishTaxConfig, partner, type, rawYaml);
      yield put(actions.publishTaxConfigSuccess(response.data));
      yield put(actions.getTaxConfigsRequest(partner));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.publishTaxConfigFail(e.response ? e.response.data : {}));
    }
  }
}

export function* createTaxConfigWatcher() {
  while (true) {
    const { payload: { partner, rawYaml } } = yield take(types.CREATE_TAX_CONFIG_REQUEST);
    try {
      const response = yield call(createTaxConfig, partner, rawYaml);
      yield put(actions.createTaxConfigSuccess(response.data));
      yield put(actions.getTaxConfigsRequest(partner));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.createTaxConfigFail(e.response ? e.response.data : {}));
    }
  }
}
